import React, { useState } from "react";

const UpdateServiceslist = ({ data, handleServiceSuggestedClick,onAddNewClick,showAddNew }) => {
  const [hoveredSuggestion, setHoveredSuggestion] = useState(null);

  const handleChange = (service, e) => {
    e.preventDefault();
    e.stopPropagation();
    handleServiceSuggestedClick(service);
  };

  // Group services by category
  const groupedServices = data.reduce((acc, service) => {
    if (!acc[service.category]) {
      acc[service.category] = [];
    }
    acc[service.category].push(service);
    return acc;
  }, {});

 const containerStyle = {
  backgroundColor: "#fff",
  border: "1px solid #ccc",
  zIndex: 1000,
  maxHeight: "400px",   // still scrollable if very large
  overflowY: "auto",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  width: "100%",        // take full width of parent input
  padding: "10px",
  borderRadius: "5px",
  marginTop: "4px"      // spacing below input
};


  const categoryStyle = {
    fontWeight: "bold",
    padding: "8px 5px",
    backgroundColor: "#f8f8f8",
    borderBottom: "1px solid #ddd",
  };

  const itemStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
  };

  return (
    <div style={containerStyle}>
      {Object.entries(groupedServices).map(([category, services]) => (
        <div key={category}>
          <div style={categoryStyle}>{category}</div>
          {services.map((service, index) => (
            <div
              key={service._id}
              onClick={(e) => handleChange(service, e)}
              style={{
                ...itemStyle,
                backgroundColor: hoveredSuggestion === service._id ? "#6174DD" : "white",
                color: hoveredSuggestion === service._id ? "white" : "black",
              }}
              onMouseEnter={() => setHoveredSuggestion(service._id)}
              onMouseLeave={() => setHoveredSuggestion(null)}
            >
              <span>{service.serviceName}</span>
              <span>₹{service.price}</span>
            </div>
          ))}
        </div>
      ))}
      {showAddNew && (
        <div
          onClick={onAddNewClick}
          style={{
            ...itemStyle,
            color: "#007bff",
            fontWeight: "bold",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          ➕ Add New Service
        </div>
      )}
    </div>
  );
};

export default UpdateServiceslist;